export default {
  wordDefaultTemplate: () => ({ name: 'Exemple : Modèle de compte rendu.docx', url: './files/exemple-modele-de-compte-rendu.docx' }),
};
